import { Component, OnInit,ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

// import { LoanService } from "../../shared/loan.service";
import { Loantransaction } from "../../shared/loantransaction.model";
import { PrintloanreceiptService } from "../../shared/print/printloanreceipt.service";
import { PrintloantransactionlistService } from "../../shared/print/printloantransactionlist.service";
import { LoantransactionService } from "../../shared/loantransaction.service";


@Component({
  selector: 'app-loanreceiptlist',
  templateUrl: './loanreceiptlist.component.html',
  styleUrls: ['./loanreceiptlist.component.css']
})
export class LoanreceiptlistComponent implements OnInit {

  displayedColumns: string[] = ['Id','LoanNo', 'ReceiptNo', 'ReceiptDate', 'Name','ReceiptAmount','CollectionAmount','New'];

  LoanReceiptList$ =[''];
  loantransaction: Loantransaction;
  ToReceiptForm: Boolean = true;

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  // constructor(private router: Router,public loanService:LoanService,
  //  private printloanreceiptService: PrintloanreceiptService) { }

    constructor(private router: Router,
                private loantransactionService:LoantransactionService,
                private printloanreceiptService: PrintloanreceiptService,
                private printloantransactionlistService: PrintloantransactionlistService
   ) { }
   
  ngOnInit() {
    this.getLoanreceiptList();
    this.dataSource.paginator = this.paginator;
  }

  getLoanreceiptList(){
    // this.loanService.FetchLoanreceiptList()
   
    this.loantransactionService.FetchLoantransactionList(this.ToReceiptForm)
    .toPromise()
    .then(data =>{
      this.dataSource.data = data;
    })
    .catch(err => { console.log(err) });
  }

  public AddNew()
  {
    this.router.navigate(['/loanreceipt']);
  }

  Edit(loan : any){
    this.router.navigate(['/loanreceipt',loan.Id]);
  }

  View(loan : any){
    this.router.navigate(['/loanreceipt',loan.Id]);
  }

  // Print(txt: any,loanReceipt : any){

    // loanReceipt.ReportName = "LoanReceiptReportById";
    // this.printloanreceiptService.GenerateReport(loanReceipt);
  // }
    
  Print(txt: any,loanTransaction : any){
    this.printloantransactionlistService.GenerateReport(this.ToReceiptForm,loanTransaction);
    // this.printloanreceiptService.GenerateReport(loanTransaction);
  }

  applyFilter(filterValue: string) {

    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

}
